// tamagui-ignore
import React from 'react'

import ExpoStripeGL, { Gradient } from 'expo-stripe-gl'

import { styled, useThemeName } from 'tamagui'

const GRADIENT_COLOURS_LIGHT = ['#E18BF3', '#FF88C5', '#FD89B4', '#FFA18F'] // brighter pinkish/purple/orange
const GRADIENT_COLOURS_DARK = ['#C45CE8', '#E458AC', '#D85888', '#E87868'] // bright purple/magenta/rose

// Wrap with forwardRef so styled() doesn't warn about passing refs to a plain function component
const ForwardRefExpoGL = React.forwardRef<any, React.ComponentProps<typeof ExpoStripeGL>>(
  (props, _ref) => <ExpoStripeGL {...props} />
)

const StyledExpoGL = styled(ForwardRefExpoGL, {
  width: '100%',
  height: 590,

  borderRadius: '$6',
})

export const HomeScreenGradient = StyledExpoGL.styleable<{
  getGradient?: (gradient: Gradient) => any
}>(({ getGradient, ...props }, ref) => {
  const isDark = useThemeName() === 'dark'

  return (
    <StyledExpoGL
      ref={ref}
      {...props}
      config={{
        colors: isDark ? GRADIENT_COLOURS_DARK : GRADIENT_COLOURS_LIGHT,
        // activeColors: gradientColours.map(() => true),
        // wireframe: true,
        speed: 0.8,
        // speed: 50,
        // shadowPower: [-1, -1, -1],
        // density: [0.1, 0.1],
        density: [0.03, 0.06],
        // blendDistance: 24,
        scale: [100, 200, 600],
        // scale: [140, 290, 320],
        // darkenTop: false,
      }}
      getGradient={(g) => {
        if (getGradient) {
          getGradient(g)
        }
      }}
    />
  )
})
